import React, { Component } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import SearchTags from '../components/searchtags';
import SearchBar from './SearchBar';
import SearchTitleBar from '../components/searchtitlebar';
import SearchResult from '../components/searchresult';
import Pagination from 'react-js-pagination';
import Loader from '../components/loader';
import EsriLeafletMap from '../components/esrileafletmap';
import Footer from '../components/footer';
import {decodeSearchParams, 
    convertPolygoneFormat, convertPolygonUnformat, getPropertyTypeName,
    GetSectionCustomizationOptions } from '../components/util';
import BookmarkTitle from '../components/bookmarktitle';
import Cookies from 'universal-cookie';
import BookmarkNote from '../components/bookmarknote';
import DocumentTitle from 'react-document-title';
import { PageTitle } from '../components/util';
import { Popover, OverlayTrigger } from 'react-bootstrap';
import {orderBy} from 'lodash';
import { Element, scroller } from 'react-scroll';
import CommutePopup from '../components/commutepopup';
import PropTypes from 'prop-types';
import base64 from 'base-64';
import utf8 from 'utf8';
import * as sessionActions from 'actions/session';
import * as searchActions from 'actions/search';
import * as profileActions from 'actions/profile';
import * as clientActions from 'actions/clients';
import * as listingActions from 'actions/listings';
import * as manageActions from 'actions/manage';
import commute_solo from '../img/svg/transicon_solo.svg';
import { Helmet } from "react-helmet";
import {GetMetaTagsProperties} from '../components/util';

const MetaTagsProperties = GetMetaTagsProperties();
const ThemeCustomizationOptions = GetSectionCustomizationOptions("ThemeOptions");
const SearchPageCustomizationOptions = GetSectionCustomizationOptions("SearchPageOptions");
const AdminCustomizationOptions = GetSectionCustomizationOptions("AdminOptions");
const FooterCustomizationOptions = GetSectionCustomizationOptions("FooterOptions");

const navBarHeight = (ThemeCustomizationOptions && ThemeCustomizationOptions.MainMenuBarClass === "menu-large") ? 106 : 66; //38
const filterBarHeight = (ThemeCustomizationOptions && ThemeCustomizationOptions.MainSearchBarClass === "compact-search") ? 54 : 63;
const mobileFilterBarHeight = (ThemeCustomizationOptions && ThemeCustomizationOptions.MainSearchBarClass === "compact-search") ? 67 : 67;
var mobileExtraBarHeight = 0; 
var listingSectionOneColumnWidth = 601;
const listingSectionTwoColumnWidth = 815;


class SearchPage extends Component {

    static propTypes = {
        history: PropTypes.object.isRequired
    };

    constructor(props) {
        super(props);

        const activePageNumber = this.checkParamForPageNumber() ? this.getCurrentPageNumberFromUrl() : 1;
        const { audience, profile, selectedClient } = this.props;

        var commuteLocation = "";
        var selectedClientId = null;

        if(audience && audience.type === 'client'){
            var uProfile = profile;
            if(uProfile !== undefined && uProfile !== null) {
                //Based on client's requirement we don't consider client's commute any more
                //commuteLocation = getUserCommuteLocation(uProfile);
            }
        }
        else {
            var sClient = selectedClient;
            if(sClient !== undefined && sClient !== null) {
                //Based on client's requirement we don't consider selected client's commute any more
                //commuteLocation = getUserCommuteLocation(sClient);
                if(sClient.Id) selectedClientId = sClient.Id;
            }
            else
            {
                var mCommute = this.props.searchParameters_Redux.commuteaddress;
                if(mCommute !== undefined && mCommute !== null && mCommute !== "")
                {
                    commuteLocation = mCommute;
                }
            }
        }

        if(!this.props.isAnonymous){
            mobileExtraBarHeight = 26;
        }

        if(this.props.match && this.props.match.params && this.props.match.params.searchparams){
            var sparams = decodeSearchParams(this.props.match.params.searchparams);
            if(sparams.commuteaddress && sparams.commuteaddress !== ""){
                commuteLocation = sparams.commuteaddress;
            }
        }

        if(window.innerWidth >= 768 && window.innerWidth <= 1023){
            listingSectionOneColumnWidth = 350;
        }
        else{
            listingSectionOneColumnWidth = 601;
        }

        var showMap = true;
        var wrapperHeight = (window.innerHeight > (navBarHeight + filterBarHeight)) ? (window.innerHeight - (navBarHeight + filterBarHeight)) : window.innerHeight;
        var mapWidth = (window.innerWidth > listingSectionOneColumnWidth) ? (window.innerWidth - listingSectionOneColumnWidth) : window.innerWidth;
        var listWidth = window.innerWidth;
        var mapLeftPosition = (window.innerWidth > listingSectionOneColumnWidth) ? ((window.innerWidth - listingSectionOneColumnWidth)*(-1)) : (window.innerWidth*(-1));
        var leftWrapperClass = "";
        var rightWrapperClass = "";

        if(window.innerWidth <= 767){
            showMap = false;
            wrapperHeight = (window.innerHeight > (navBarHeight + mobileFilterBarHeight + mobileExtraBarHeight)) ? (window.innerHeight - (navBarHeight + mobileFilterBarHeight + mobileExtraBarHeight)) : window.innerHeight;
            mapWidth = window.innerWidth;
            listWidth = 0;
            mapLeftPosition = 0;
        }

        this.state = {
            title: 'Find Homes',
            fetchingResult: false,
            searchResult: [],
            resultList: [],
            pageIndexList: [],
            homeFeatures: [],
            searchInitiator: "searchbar",
            initialLoad: true,
            activePage: activePageNumber,
            recordsPerPage: 20,
            recordsPerRequest: 100,
            pageRangeDisplayed: 3,
            totalRecords: 0,
            activePageStart: activePageNumber === 1 ? 1 : (activePageNumber - 1)* 10 + 1,
            activePageEnd: activePageNumber * 10,
            breadcrumdata: {
                state: "",
                city: ""
            },
            showMap: showMap,
            wrapperHeight: wrapperHeight,
            mapWidth: mapWidth,
            listWidth: listWidth,
            mapLeftPosition: mapLeftPosition,
            bookmarkItems: [],
            mapListToggleRightButtonClass: "",
            mapListToggleLeftButtonClass: "",
            leftWrapperClass: leftWrapperClass,
            rightWrapperClass: rightWrapperClass,
            commuteLocation: commuteLocation,
            selectedClientId: selectedClientId,
            commuteTimeMins: (this.props.searchParameters_Redux && this.props.searchParameters_Redux.commutetimemins) ? this.props.searchParameters_Redux.commutetimemins : "45"
        };
        this.onSearch = this.onSearch.bind(this);
        this.onPageChange = this.onPageChange.bind(this);
        this.onChangeView = this.onChangeView.bind(this);
        this.onFocus = this.onFocus.bind(this);
        this.updateWindowDimensions = this.updateWindowDimensions.bind(this);
        this.onRemoveSearchTag = this.onRemoveSearchTag.bind(this);
        this.onChangeSort = this.onChangeSort.bind(this);
        this.onChangeImageType = this.onChangeImageType.bind(this);
        this.highlightMarker = this.highlightMarker.bind(this);
        this.playdownMarker = this.playdownMarker.bind(this);
        this.onMapPolygoneChanged = this.onMapPolygoneChanged.bind(this);

        this.onMarkBookmarkFromClient = this.onMarkBookmarkFromClient.bind(this);
        this.onClientSelectionForBookmark = this.onClientSelectionForBookmark.bind(this);
        this.onBookmarkNoteSaved = this.onBookmarkNoteSaved.bind(this);
        this.onBookmarkNoteClosed = this.onBookmarkNoteClosed.bind(this);
        this.onPageReload = this.onPageReload.bind(this);
        this.moveMapToRight = this.moveMapToRight.bind(this);
        this.moveMapToLeft = this.moveMapToLeft.bind(this);

        this.workingWithClient = this.workingWithClient.bind(this);

        this.handleAutoComplete = this.handleAutoComplete.bind(this);

        this.onBookmarkClicked = this.onBookmarkClicked.bind(this);
        this.onListingRemoved = this.onListingRemoved.bind(this);

        this.updateCommuteToProfile = this.updateCommuteToProfile.bind(this);

        this.handleCommuteTimeChange = this.handleCommuteTimeChange.bind(this);
        this.handleSelectClientCommute = this.handleSelectClientCommute.bind(this);

    }

    componentDidMount(){
        if (!this.props.showHeader) {
            this.props.onShowHideHeader(true);
        }
        if (this.props.showFooter) {
            this.props.onShowHideFooter(false);
        }
        this.updateWindowDimensions();
        window.addEventListener('resize', this.updateWindowDimensions);

        this.props.listingActions.fetchFeaturedListings('exteriorstyle');
    }

    componentWillUnmount() {
        window.removeEventListener('resize', this.updateWindowDimensions);
    }

    componentWillReceiveProps(nextProps) {
        if (JSON.stringify(this.props.selectedClient) !== JSON.stringify(nextProps.selectedClient) ||
            (this.props.profile === null && nextProps.profile !== null)) {
            this.workingWithClient(nextProps.selectedClient, nextProps.profile);
        }

        if (this.props.notificationMessage !== nextProps.notificationMessage && nextProps.notificationMessage) {
            this.props.showNotification(
                "success",
                "",
                nextProps.notificationMessage,
                5000
            );
            this.workingWithClient(nextProps.selectedClient, nextProps.profile);
        }

        if(AdminCustomizationOptions && AdminCustomizationOptions.AllowAdsManagement){
            if(SearchPageCustomizationOptions && SearchPageCustomizationOptions.ShowCustomAds &&
                JSON.stringify(this.props.pAdsList) !== JSON.stringify(nextProps.pAdsList)){
                
                var adsList = [].concat(nextProps.pAdsList || []);
                adsList = adsList.filter(a => a.AdType !== "googletag" && !a.SkipEvent);                

                if(adsList && adsList.length > 0){
                    this.props.manageActions.trackEvent("post_impress", { 
                        EventName: "post_impress",
                        UserId: this.props.audience.Id,
                        AdModel: adsList
                    });
                }
            }
        }

        if(this.props.isAnonymous !== nextProps.isAnonymous){
            if(!nextProps.isAnonymous){
                mobileExtraBarHeight = 26;
            }
            else{
                mobileExtraBarHeight = 0;
            }
            this.updateWindowDimensions();
        }
    }

    componentWillUpdate(nextProps, nextState)
    {
        if (JSON.stringify(this.props) !== JSON.stringify(nextProps)) {
            return true;
        }

        return false;
    }

    updateWindowDimensions() {
        
        if(window.innerWidth >= 768 && window.innerWidth <= 1023){
            listingSectionOneColumnWidth = 350;
        }
        else{
            listingSectionOneColumnWidth = 601;
        }

        var rightWrapperClass = this.state.rightWrapperClass;
        var wrapperHeight = (window.innerHeight > (navBarHeight + filterBarHeight)) ? (window.innerHeight - (navBarHeight + filterBarHeight)) : window.innerHeight;
        
        var listWidth = this.state.listWidth;
        var mapLeftPosition = this.state.mapLeftPosition;
        var mapWidth = this.state.mapWidth;
        var pageRangeDisplayed = this.state.pageRangeDisplayed;

        if(this.state.showMap){
            if(rightWrapperClass === "map-full"){
                listWidth = 0;
                mapWidth = window.innerWidth;
                mapLeftPosition = 0;
                pageRangeDisplayed = 3;
            }
            else if(rightWrapperClass === ""){
                listWidth = listingSectionOneColumnWidth;
                mapWidth = (window.innerWidth > listingSectionOneColumnWidth) ? (window.innerWidth - listingSectionOneColumnWidth) : window.innerWidth;
                mapLeftPosition = 0;
                pageRangeDisplayed = 5;
                if(window.innerWidth >= 768 && window.innerWidth <= 1023){
                    pageRangeDisplayed = 3;
                }
            }
            else if(rightWrapperClass === "list-col-2"){
                listWidth = listingSectionTwoColumnWidth;
                mapWidth = (window.innerWidth > listingSectionTwoColumnWidth) ? (window.innerWidth - listingSectionTwoColumnWidth) : window.innerWidth;
                mapLeftPosition = 0;
                pageRangeDisplayed = 5;

                if(window.innerWidth <= 768){
                    listWidth = window.innerWidth - 21;
                    mapLeftPosition = ((mapWidth - 21)*(-1));
                    pageRangeDisplayed = 5;
                }
            }
            else if(rightWrapperClass === "list-full"){
                listWidth = window.innerWidth - 36;
                mapLeftPosition = ((mapWidth - 36)*(-1));
                pageRangeDisplayed = 10;

                if(window.innerWidth <= 1024){
                    listWidth = window.innerWidth - 21;
                    mapLeftPosition = ((mapWidth - 21)*(-1));
                }
            }
            if(window.innerWidth <= 767){
                listWidth = 0;
                mapWidth = window.innerWidth;
                mapLeftPosition = 0;
                pageRangeDisplayed = 5;
            }
        }
        else {
            listWidth = window.innerWidth;
            mapLeftPosition = (window.innerWidth > listingSectionOneColumnWidth) ? ((window.innerWidth - listingSectionOneColumnWidth)*(-1)) : (window.innerWidth*(-1));
            pageRangeDisplayed = 5;

            if(window.innerWidth <= 767){
                mapLeftPosition = (window.innerWidth*(-1));
            }
        }
        if(window.innerWidth <= 767){
            wrapperHeight = (window.innerHeight > (navBarHeight + mobileFilterBarHeight + mobileExtraBarHeight)) ? (window.innerHeight - (navBarHeight + mobileFilterBarHeight + mobileExtraBarHeight)) : window.innerHeight;
        }
        var self = this;
        if(this.refs.searchPageRef) {
            this.setState({
                wrapperHeight: wrapperHeight,
                listWidth: listWidth,
                mapWidth: mapWidth,
                mapLeftPosition: mapLeftPosition,
                pageRangeDisplayed: pageRangeDisplayed
            }, () => {
                if(self.props.searchParameters_Redux && self.props.searchParameters_Redux.view === "map"){
                    self.moveMapToRight();
                }
                else if(self.props.searchParameters_Redux && self.props.searchParameters_Redux.view === "list"){
                    self.moveMapToLeft();
                }
            });
        }
    }

    checkParamForPageNumber = () => {
        return new RegExp('page_number', 'ig').test(window.location.pathname);
    };

    getCurrentPageNumberFromUrl = () => {
        let _page = window.location.pathname.split('&').filter((ele) => new RegExp('page_number', 'ig').test(ele));
        return parseInt(_page[0].split("=")[1]);
    };


    moveMapToRight() {
        
        var self = this;
        var leftWrapperClass = this.state.leftWrapperClass;
        var rightWrapperClass = this.state.rightWrapperClass;
        var mapListToggleRightButtonClass = this.state.mapListToggleRightButtonClass;
        var mapListToggleLeftButtonClass = this.state.mapListToggleLeftButtonClass;

        var wrapperHeight = (window.innerHeight > (navBarHeight + filterBarHeight)) ? (window.innerHeight - (navBarHeight + filterBarHeight)) : window.innerHeight;
        
        var listWidth = this.state.listWidth;
        var mapLeftPosition = this.state.mapLeftPosition;
        var mapWidth = this.state.mapWidth;
        var pageRangeDisplayed = this.state.pageRangeDisplayed;

        var refreshMap = false;
        if(rightWrapperClass === ""){
            leftWrapperClass = rightWrapperClass = "map-full";
            mapListToggleRightButtonClass = "inactive";
            mapListToggleLeftButtonClass = "";

            listWidth = 0;
            mapWidth = window.innerWidth;
            mapLeftPosition = 0;
            pageRangeDisplayed = 5;
            refreshMap = true;

            let parameters = Object.assign({}, this.props.searchParameters_Redux);
            parameters.view = "map";
            this.props.searchActions.updateParameters(parameters);
        }
        else if(rightWrapperClass === "list-full"){
            leftWrapperClass = rightWrapperClass = "";
            mapListToggleRightButtonClass = mapListToggleLeftButtonClass = "";

            listWidth = listingSectionOneColumnWidth;
            mapWidth = (window.innerWidth > listingSectionOneColumnWidth) ? (window.innerWidth - listingSectionOneColumnWidth) : window.innerWidth;
            mapLeftPosition = 0;
            pageRangeDisplayed = 5;
            if(window.innerWidth >= 768 && window.innerWidth <= 1023){
                pageRangeDisplayed = 3;
            }

            if(window.innerWidth > 1600){
                refreshMap = true;
            }

            let parameters = Object.assign({}, this.props.searchParameters_Redux);
            parameters.view = "maplist";
            this.props.searchActions.updateParameters(parameters);
        }
        if(window.innerWidth <= 767){
            wrapperHeight = (window.innerHeight > (navBarHeight + mobileFilterBarHeight + mobileExtraBarHeight)) ? (window.innerHeight - (navBarHeight + mobileFilterBarHeight + mobileExtraBarHeight)) : window.innerHeight;
        }
        if(this.refs.searchPageRef) {
            this.setState({
                leftWrapperClass: leftWrapperClass, rightWrapperClass: rightWrapperClass,
                mapListToggleRightButtonClass: mapListToggleRightButtonClass,
                mapListToggleLeftButtonClass: mapListToggleLeftButtonClass,
                wrapperHeight: wrapperHeight,
                listWidth: listWidth,
                mapWidth: mapWidth,
                mapLeftPosition: mapLeftPosition,
                pageRangeDisplayed: pageRangeDisplayed,
                moveWrapperClass: ""
            },() => {
                if(refreshMap){
                    if(self.esriMap && self.esriMap.getWrappedInstance() && self.state.showMap){
                        self.esriMap.getWrappedInstance().refreshMap();
                    }
                }
            });
        }
    }

    moveMapToLeft() {
        
        var self = this;
        var leftWrapperClass = this.state.leftWrapperClass;
        var rightWrapperClass = this.state.rightWrapperClass;
        var mapListToggleRightButtonClass = this.state.mapListToggleRightButtonClass;
        var mapListToggleLeftButtonClass = this.state.mapListToggleLeftButtonClass;

        var wrapperHeight = (window.innerHeight > (navBarHeight + filterBarHeight)) ? (window.innerHeight - (navBarHeight + filterBarHeight)) : window.innerHeight;
        
        var listWidth = this.state.listWidth;
        var mapLeftPosition = this.state.mapLeftPosition;
        var mapWidth = this.state.mapWidth;
        var pageRangeDisplayed = this.state.pageRangeDisplayed;

        var refreshMap = false;
        if(leftWrapperClass === ""){
            leftWrapperClass = rightWrapperClass = "list-full";
            mapListToggleRightButtonClass = "";
            mapListToggleLeftButtonClass = "inactive";

            listWidth = window.innerWidth - 36;
            mapLeftPosition = ((mapWidth - 36)*(-1));
            pageRangeDisplayed = 10;

            if(window.innerWidth <= 1024){
                listWidth = window.innerWidth - 21;
                mapLeftPosition = ((mapWidth - 21)*(-1));
            }

            let parameters = Object.assign({}, this.props.searchParameters_Redux);
            parameters.view = "list";
            this.props.searchActions.updateParameters(parameters);
        }
        else if(leftWrapperClass === "map-full"){
            leftWrapperClass = rightWrapperClass = "";
            mapListToggleRightButtonClass = mapListToggleLeftButtonClass = "";

            listWidth = listingSectionOneColumnWidth;
            mapWidth = (window.innerWidth > listingSectionOneColumnWidth) ? (window.innerWidth - listingSectionOneColumnWidth) : window.innerWidth;
            mapLeftPosition = 0;
            pageRangeDisplayed = 5;
            if(window.innerWidth >= 768 && window.innerWidth <= 1023){
                pageRangeDisplayed = 3;
            }
            refreshMap = true;

            let parameters = Object.assign({}, this.props.searchParameters_Redux);
            parameters.view = "maplist";
            this.props.searchActions.updateParameters(parameters);
        }
        if(window.innerWidth <= 767){
            wrapperHeight = (window.innerHeight > (navBarHeight + mobileFilterBarHeight + mobileExtraBarHeight)) ? (window.innerHeight - (navBarHeight + mobileFilterBarHeight + mobileExtraBarHeight)) : window.innerHeight;
        }
        if(this.refs.searchPageRef) {
            this.setState({
                leftWrapperClass: leftWrapperClass, rightWrapperClass: rightWrapperClass,
                mapListToggleRightButtonClass: mapListToggleRightButtonClass,
                mapListToggleLeftButtonClass: mapListToggleLeftButtonClass,
                wrapperHeight: wrapperHeight,
                listWidth: listWidth,
                mapWidth: mapWidth,
                mapLeftPosition: mapLeftPosition,
                pageRangeDisplayed: pageRangeDisplayed
            },() => {
                if(refreshMap){
                    if(self.esriMap && self.esriMap.getWrappedInstance() && self.state.showMap){
                        self.esriMap.getWrappedInstance().refreshMap();
                    }
                }
            });
        }
    }

    onSearch(parameters, data, commuteLocation, sClient) {
        var pgnm = parameters.page_number;
        let _result_set = data.Listings || [];

        let pageIndexList = this.state.pageIndexList.slice();

        if(pgnm === 1){
            pageIndexList = [];
        }

        let cnt = (data.ResultsCount) ? data.ResultsCount : 0;

        var pExists = null;
        if(data && data.Listings && data.Listings.length > 0){
            var currentPgnm = pgnm;
            var dcnt = 0;
            var pgObj = {};

            for (var i = 0; i < data.Listings.length; i++) {
                if(dcnt === 0 || dcnt === this.state.recordsPerPage) {
                    pgObj = {pgnm: currentPgnm, records: []};
                }

                pgObj.records.push(data.Listings[i].Id);
                dcnt++;

                if(dcnt === this.state.recordsPerPage || i === (data.Listings.length - 1)){
                    // eslint-disable-next-line
                    pExists = pageIndexList.filter(p => p.pgnm === currentPgnm);
                    if(pExists === undefined || pExists === null || !pExists || pExists.length === 0){
                        pageIndexList.push(pgObj);
                    }
                    dcnt = 0;
                    currentPgnm++;
                }
            }
        }
        pageIndexList = orderBy(pageIndexList, ((a) => a.pgnm));

        let st = ((pgnm - 1) * this.state.recordsPerPage) + 1;
        let ed = (st + this.state.recordsPerPage - 1);
        ed = ed >= cnt ? cnt : ed;

        let sBoundaries = (data && data.Boundaries) ? data.Boundaries : [];

        if(sBoundaries.length > 0 && sBoundaries[0].Multipolygon && sBoundaries[0].Multipolygon.length > 0)
        {

        }
        else if(sBoundaries.length > 0 && sBoundaries[0].Polygon && sBoundaries[0].Polygon.length > 0)
        {
            // Only found a single polygon
            sBoundaries[0].Multipolygon = [];
            sBoundaries[0].Multipolygon.push(data.Boundaries[0].Polygon);
        }

        if(parameters.cpolygon && parameters.cpolygon.length > 0 && commuteLocation && commuteLocation !== ""){
            var polygonBoundaries = {};
            polygonBoundaries.BoundaryName = commuteLocation;

            polygonBoundaries.Multipolygon = [];
            var mPolygon = [];

            parameters.cpolygon.map(function (poly, i){
                var polys = poly.split(',');
                if(polys && polys.length > 0){
                    polys.map(function (polyObj){
                        var polyPoints = polyObj.split(' ');
                        if(polyPoints && polyPoints.length === 2){
                            mPolygon.push([polyPoints[0],polyPoints[1]]);
                        }
                        return <div />
                    });
                    polygonBoundaries.Multipolygon.push(mPolygon);
                }

                return <div/>;
            });

            sBoundaries.push(polygonBoundaries);
        }

        var commuteTimeMins = this.state.commuteTimeMins;
        if(parameters.commuteaddress && parameters.commutetimemins) {
            commuteTimeMins = parameters.commutetimemins;
        }
        if(this.refs.searchPageRef) {
            const {recordsPerPage} = this.state;
            this.setState({
                searchResult: _result_set,
                clusters: data.ClusterResults,
                resultsCount: data.ResultsCount,
                resultList: _result_set.slice(0, recordsPerPage),
                initialLoad: false, totalRecords: cnt,
                activePage: pgnm, activePageStart: st, activePageEnd: ed,
                searchInitiator: "searchbar", searchBoundaries: sBoundaries,
                pageIndexList: pageIndexList,
                commuteTimeMins: commuteTimeMins,
                homeFeatures: data.HomeFeatures
            });
        }
    }

    onPageChange(pageNumber) {
        var pExists = this.state.pageIndexList.filter(p => p.pgnm === pageNumber);
        if(pExists && pExists.length > 0 && pExists[0].records && pExists[0].records.length > 0){
            let resultlst = pExists[0].records.map(e => this.state.searchResult.filter(l => l.Id === e));
            resultlst = resultlst.map(m => m[0]);

            let st = ((pageNumber - 1) * this.state.recordsPerPage) + 1;
            let ed = (st + this.state.recordsPerPage - 1);
            ed = ed >= this.state.totalRecords ? this.state.totalRecords : ed;

            if(this.refs.searchPageRef) {
                this.setState({
                    activePage: pageNumber,
                    activePageStart: st,
                    activePageEnd: ed,
                    resultList: resultlst,
                    initialLoad: true,
                    searchInitiator: "list"});
            }
        }
        else{
            let parameters = Object.assign({}, this.props.searchParameters_Redux);
            parameters.skip = (pageNumber - 1) * this.state.recordsPerPage;
            parameters.pagechange = true;

            if(this.refs.searchPageRef) {
                this.setState({initialLoad: true, searchInitiator: "list"});
            }
            this.props.searchActions.updateParameters(parameters, true);
        }

		if(window.innerWidth <= 767){
            scroller.scrollTo('top_scroll', {containerId: 'root', offset:-100});
        }
        else{
            scroller.scrollTo('top_scroll', {containerId: 'right-wrapper', offset:-100});
        }
        let parameters = Object.assign({}, this.props.searchParameters_Redux);
        parameters.page_number = pageNumber;
        parameters.skip = (pageNumber - 1) * this.state.recordsPerPage;
        parameters.pagechange = true
        this.props.searchActions.updateParameters(parameters, true);
    }

    getActivePageStart(currentPage) {
        let st = ((currentPage - 1) * this.state.recordsPerPage) + 1;
        if (st === 0) st = 1;
        return st;
    }

    getActivePageEnd(currentPage, total) {
        let ed = currentPage * this.state.recordsPerPage;
        if (ed > total) ed = total;
        return ed;
    }

    onChangeView(showmap) {
        var listWidth = this.state.listWidth;
        var mapLeftPosition = this.state.mapLeftPosition;
        var pageRangeDisplayed = this.state.pageRangeDisplayed;
        if(showmap){
            listWidth = window.innerWidth;
            mapLeftPosition = (window.innerWidth > listingSectionOneColumnWidth) ? ((window.innerWidth - listingSectionOneColumnWidth)*(-1)) : (window.innerWidth*(-1));
            pageRangeDisplayed = 5;

            if(window.innerWidth <= 767){
                mapLeftPosition = (window.innerWidth*(-1));
            }
        }
        else {
            listWidth = listingSectionOneColumnWidth;
            mapLeftPosition = 0;
            pageRangeDisplayed = 3;

            if(window.innerWidth <= 767){
                listWidth = 0;
            }
        }
        if(this.refs.searchPageRef) {
            this.setState({showMap: !showmap, listWidth: listWidth, mapLeftPosition: mapLeftPosition, pageRangeDisplayed: pageRangeDisplayed});
        }
    }

    onMapPolygoneChanged(polys) {
        let parameters = Object.assign({}, this.props.searchParameters_Redux);

        if(polys && polys.length > 0){
            let searchPoly = [];

            polys.map((eachPoly) => {
                searchPoly.push(convertPolygoneFormat(eachPoly));
                return <div />;
            });

            if(searchPoly.length > 0) {
                parameters.polygon = searchPoly;
            }
        }
        else {
            delete parameters['polygon'];
        }

        this.setState({searchInitiator: "drawmap"});
        this.props.searchActions.updateParameters(parameters);
    }

    onChangeSort(orderby, orderbydirection){
        if(orderby && orderby !== "" && orderbydirection && orderbydirection !== ""){
            let parameters = Object.assign({}, this.props.searchParameters_Redux);
            parameters.orderby = orderby;
            parameters.orderbydirection = orderbydirection;
            if(this.refs.searchPageRef) {
                this.setState({searchInitiator: "sortby"});
            }
            this.props.searchActions.updateParameters(parameters);
        }
    }

    onChangeImageType(imgtype, extimgtype){
        let parameters = Object.assign({}, this.props.searchParameters_Redux);
        delete parameters["imagetype"];
        delete parameters["exteriorhomestyle"];
        parameters.page_number = 1;
        parameters.skip = 0;
        if(imgtype && imgtype !== ""){
            parameters.imagetype = imgtype;
        }
        if(extimgtype && extimgtype !== ""){
            parameters.exteriorhomestyle = extimgtype;
        }
        if(this.refs.searchPageRef) {
            this.setState({searchInitiator: "imagetype"});
        }
        this.props.searchActions.updateParameters(parameters);
    }

    onRemoveSearchTag(tag, val){
        
        var commuteLocation = this.state.commuteLocation;
        var commuteTimeMins = this.state.commuteTimeMins;
        let parameters = JSON.parse(JSON.stringify(Object.assign({},this.props.searchParameters_Redux)));
        parameters.page_number = 1;
        parameters.skip = 0;

        if(tag.toLowerCase() === "location" || tag.toLowerCase() === "mlsnumber"){
            delete parameters[tag];
            delete parameters["locationtext"];
            window.sessionStorage.setItem("ClearLocationText","true");
        }
        else if(Array.isArray(parameters[tag])){
            var pvalArr = val;
            if(tag.toLowerCase() === "propertytype") pvalArr = getPropertyTypeName(val, true);
            if(tag.toLowerCase() === "homefeatures") pvalArr = pvalArr.toLowerCase().replace(/ /g,'_');
            parameters[tag] = parameters[tag].filter(m => m.indexOf(pvalArr) === -1);
            if(parameters[tag].length === 0){ 
                delete parameters[tag];
            }
        }
        else if(tag.toLowerCase() === "postalcode" &&  parameters[tag].indexOf(",") > -1 && (parameters[tag].split(",")).length > 0){
            var pval = val;
            parameters[tag] = parameters[tag].split(",").filter(m => m.indexOf(pval) === -1);
            if(parameters[tag].length === 0){ 
                delete parameters[tag];
            }
            else{
                parameters[tag] = parameters[tag].join(",");
            }
        }
        else{
            delete parameters[tag];
        }

        if(tag.toLowerCase() === "commuteaddress"){

            delete parameters["commuteaddress"];
            delete parameters["cpolygon"];

            delete parameters["commutetimemins"];
            commuteTimeMins = "45";
        }
        else if (tag.toLowerCase() === "openhouseonly"){
            delete parameters["openhousefromdate"];
            delete parameters["openhousetodate"];
        }

        if(tag.toLowerCase() === "searchmap"){
            delete parameters["mapbound"];
        }

        this.setState({searchInitiator: "searchtags", commuteLocation: commuteLocation, commuteTimeMins: commuteTimeMins});
        this.props.searchActions.updateParameters(parameters);

    }

    onFeatureSelected = (features) => {
        const { searchParameters_Redux, searchActions } = this.props;
        const homeFeatures = { 'homeFeatures': features };
        searchActions.updateParameters({...searchParameters_Redux, ...homeFeatures});
    }

    highlightMarker(id){
        if(this.esriMap && this.esriMap.getWrappedInstance() && this.state.showMap){
            this.esriMap.getWrappedInstance().highlightMarker(id);
        }
    }

    playdownMarker(id){
        if(this.esriMap && this.esriMap.getWrappedInstance() && this.state.showMap){
            this.esriMap.getWrappedInstance().playdownMarker(id);
        }
    }

    onMarkBookmarkFromClient(selectedProperty)
    {
        if(window.sessionStorage.getItem("APIAudience") === 'clients/')
        {
            var propIDToDelete = [];
            propIDToDelete.push(selectedProperty.Id);

            this.updateBookmark("DELETE", JSON.stringify(propIDToDelete), null);
        }
        else
        {
            var tmpBookmark = this.state.bookmarkItems;
            if(tmpBookmark)
            {
                var itemPosition = tmpBookmark.indexOf(selectedProperty.Id);
                if(itemPosition === -1)
                {
                    tmpBookmark.push(selectedProperty.Id)
                }
                else
                {
                    tmpBookmark.splice(itemPosition, 1);
                }
            }

            this.setState({bookmarkItems: tmpBookmark});
        }
    }

    onClientSelectionForBookmark(SelectedClientForBookmark)
    {
        if(SelectedClientForBookmark && this.state.bookmarkItems && this.state.bookmarkItems.length > 0)
        {
            this.setState({openBookmarkNote: true, SelectedClientForBookmark: SelectedClientForBookmark});
        }
    }

    onBookmarkNoteClosed() {
        this.setState({openBookmarkNote: false});
    }

    onBookmarkNoteSaved(Note, SendEmail, isDataFetching)
    {
        var bookmarkRequest = {};
        bookmarkRequest.ListingIds = this.state.bookmarkItems;
        bookmarkRequest.Note = Note;
        bookmarkRequest.SendEmail = SendEmail;

        //If there is default agent then pass default agent id to use default agent specific email template
        if (process.env.REACT_APP_DefaultAgentId !== undefined &&
            process.env.REACT_APP_DefaultAgentId !== null &&
            process.env.REACT_APP_DefaultAgentId !== "")
        {
            bookmarkRequest.BrokerAgentId = process.env.REACT_APP_DefaultAgentId;
        }
        //---

        const { selectedClient } = this.props;
        this.props.clientActions.addDeleteBookmark('POST', bookmarkRequest,
            selectedClient ? selectedClient.Id : 0);
        bookmarkRequest.ListingIds.forEach(id => {
            this.props.listingActions.addListing('bookmarks', id);
        })
        this.onBookmarkNoteClosed();
        this.setState({bookmarkItems: []});
    }

    updateBookmark(methodType, requestBody, SelectedClientForBookmark)
    {
        var url = window.sessionStorage.getItem("RootAPI") + window.sessionStorage.getItem("APIAudience");

        let self = this;
        const cookies = new Cookies();
        var authToken = cookies.get('authDetails');

        url += (window.sessionStorage.getItem("APIAudience") === 'agents/') ?
        authToken.Audience.Id + "/clients/" + SelectedClientForBookmark.Id + "/bookmarks" :
        authToken.Audience.Id + "/bookmarks";

        fetch(url,
        {
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
                'Authorization': 'Bearer ' + window.sessionStorage.getItem("APIKey")
            },
            method: methodType,
            body: requestBody
        })
        .then(response => response.json())
        .then(json => {
            if(json.Message)
            {
                self.setState({
                    bookmarkItems: [],
                    openBookmarkNote: false,
                    isDataFetching: false
                }, function(){
                    if(self.props.audience && self.props.audience.type === 'agent')
                    {
                        self.props.clientActions.fetchClient(self.props.selectedClient.Id);
                    }
                });
            }
        })
        .catch(function(data){
            console.log(data);
            this.setState({openBookmarkNote: false, isDataFetching: false});
        });
    }

    onPageReload(objResponse)
    {
        if(objResponse && this.props.showNotification) {
            if(this.state && this.state.resultList)
            {
                var tmpProperty = null;
                if(objResponse.isFavorite)
                {
                    tmpProperty = this.state.resultList.find(o => o.Id === objResponse.PropID);
                    if(tmpProperty !== undefined && tmpProperty !== null)
                    {
                        tmpProperty.IF = !tmpProperty.IF;
                    }
                }
                else if(window.sessionStorage.getItem("APIAudience") === 'clients/')
                {
                    tmpProperty = this.state.resultList.find(o => o.Id === objResponse.PropID);
                    if(tmpProperty !== undefined && tmpProperty !== null)
                    {
                        tmpProperty.IB = !tmpProperty.IB;
                    }
                }
            }

            if(objResponse.Message)
            {
                this.props.showNotification(
                    "success",
                    "",
                    objResponse.Message,
                    5000);
            }
        }
        this.setState({pageReload: true});
    }

    workingWithClient(selectedClient, profile){
        const { audience } = this.props;
        var commuteLocation = "";
        if(audience && audience.type === "client"){
            if(profile){
                //Based on client's requirement we don't consider client's commute any more
                //commuteLocation = getUserCommuteLocation(profile);
                this.setState({commuteLocation: commuteLocation});
            }
        }
        else{
            if(selectedClient !== undefined && selectedClient !== null){
                //Based on client's requirement we don't consider selected client's commute any more
                //commuteLocation = getUserCommuteLocation(selectedClient);
                var selectedClientId = null;
                if(selectedClient.Id) selectedClientId = selectedClient.Id;
                this.setState({bookmarkItems:[], commuteLocation: commuteLocation, selectedClientId: selectedClientId});
            }
            else{
                this.setState({bookmarkItems:[], commuteLocation: "", selectedClientId: null});
            }
        }
    }

    handleAutoComplete(event){
        if(this.refs.searchPageRef) {
            if(event !== undefined
                && event !== null
                && event.SearchedText !== undefined
                && event.SearchedText !== null)
                {
                    this.setState({searchInitiator : "commute"});
                }
        }
    }

    onFocus(event) {
        if (this.refs.searchPageRef) {
            if (document.getElementsByClassName('rbt-input-main').length === 2)
                document.getElementsByClassName('rbt-input-main')[1].select();
        }
    }

    onBookmarkClicked(property, flag)
    {
        var tmpBookmarkItems = this.state.bookmarkItems ? this.state.bookmarkItems : [];

        if(tmpBookmarkItems)
        {
            var itemPosition = tmpBookmarkItems.indexOf(property.Id);
            if(itemPosition === -1 && flag)
            {
                tmpBookmarkItems.push(property.Id);
            }
            else if(itemPosition >= 0 && !flag)
            {
                tmpBookmarkItems.splice(itemPosition, 1);
            }
        }
        this.setState({bookmarkItems: tmpBookmarkItems});
    }

    onListingRemoved(property){
        let resultlst = this.state.resultList.filter(n => n.Id !== property.Id);
        this.setState({ resultList: resultlst });
    }

    updateCommuteToProfile(){
        const {audience, selectedClient, profile} = this.props;
        var clientProfile = null;
        var commAddr = null;
        var commObj = null;
        if(audience && audience.type === "agent"){
            if(this.state.selectedClientId !== undefined && this.state.selectedClientId !== null &&
                this.state.selectedClientId !== "" && selectedClient !== undefined && selectedClient !== null){
                clientProfile = Object.assign({}, selectedClient);
                commAddr = this.props.searchParameters_Redux.commuteaddress;
                if(commAddr !== undefined && commAddr !== null && commAddr !== ""){
                    commObj = {CommuteDetail: [{}]};
                    if (clientProfile && clientProfile.Profile){
                        if (clientProfile && clientProfile.Profile && clientProfile.Profile.CommuteData &&
                            clientProfile.Profile.CommuteData.CommuteDetail && clientProfile.Profile.CommuteData.CommuteDetail.length > 0) {
                            commObj = clientProfile.Profile.CommuteData;
                        }
                        commObj.CommuteDetail[0].WorkAddress = commAddr;

                        clientProfile.Profile.CommuteData = commObj;

                        if(this.props.clientActions){
                            this.props.clientActions.updateClient(this.state.selectedClientId, clientProfile);
                        }
                    }
                }
            }
        }
        else if(audience && audience.type === "client"){
            if(profile !== undefined && profile !== null){
                clientProfile = Object.assign({}, profile);
                commAddr = this.props.searchParameters_Redux.commuteaddress;
                if(commAddr !== undefined && commAddr !== null && commAddr !== ""){
                    commObj = {CommuteDetail: [{}]};
                    if (clientProfile && clientProfile.Profile){
                        if (clientProfile.Profile.CommuteData && clientProfile.Profile.CommuteData.CommuteDetail &&
                            clientProfile.Profile.CommuteData.CommuteDetail.length > 0) {
                            commObj = clientProfile.Profile.CommuteData;
                        }
                        commObj.CommuteDetail[0].WorkAddress = commAddr;

                        clientProfile.Profile.CommuteData = commObj;

                        if(this.props.profileActions){
                            this.props.profileActions.updateProfile(clientProfile);
                        }
                    }
                }
            }
        }
    }

    handleCommuteTimeChange(val){
        if(this.refs.searchPageRef) {
            this.setState({commuteTimeMins: val});
        }
    }

    handleSelectClientCommute(){
        this.setState({searchInitiator : "commute"});
    }

    goToLogin = () => {
        if(window.location.pathname !== '/' && window.location.pathname !== '/profile'){
            window.sessionStorage.setItem("RedirectLocation",base64.encode(utf8.encode(window.location.pathname)));
        }
        this.props.history.push('/login');
    }

    alertForLogin = () => {
        const { isAnonymous } = this.props;

        if(isAnonymous) {
            if(this.props.showNotification) {
                this.props.showNotification(
                    "info",
                    "",
                    'You need to login to use this feature',
                    5000,
                    "Cancel",
                    null,
                    null,
                    "Login",
                    this.goToLogin
                );
            }
        }
    }

    onChangeGridListView = (flag) => {
        if(this.refs.searchPageRef) {
            if(!flag){
                this.setState({leftWrapperClass: ""},() => { this.moveMapToLeft(); });
            }
            else{
                this.setState({rightWrapperClass: "list-full"},() => { this.moveMapToRight(); });    
            }
        }
    }

    onCheckChange = (e) => {
        if(e){
            let parameters = Object.assign({},this.props.searchParameters_Redux);
            if(e.target.checked) {
                parameters[e.target.name] = "true";
            }
            else {
                delete parameters[e.target.name];
                if(e.target.name === "searchmap"){
                    delete parameters["mapbound"];
                }
            }
            parameters.page_number = 1;
            parameters.skip = 0;
            if(this.refs.searchPageRef) {
                this.props.searchActions.updateParameters(parameters);
            }
        }
    }

    render() {

        var searchURLParams = (this.props && this.props.location && this.props.location.search) ? (this.props.location.search) : null;

        let pager = null;
        let msg = (this.state.activePageStart) ? this.state.activePageStart : "";
        msg = (this.state.activePageEnd) ? msg + " - " + this.state.activePageEnd : "";
        msg = (this.state.totalRecords) ? msg + " of " + this.state.totalRecords + " Listings" : "";
        if(this.state.recordsPerPage && this.state.totalRecords && this.state.totalRecords <= this.state.recordsPerPage){
            msg = this.state.totalRecords + " Listings";
        }

        if (this.state.searchResult && this.state.searchResult.length > 0) {
            pager = (
                <div className="pagination_results property-item-pagination">
                    <div>
                        <div className="filter_results_number sorting_option_total">
                            <span className="sorting_resultsnumber">{msg}</span>
                        </div>
                        {this.state.totalRecords > 0 && this.state.totalRecords > this.state.recordsPerPage &&
                        <Pagination
                            firstPageText={<i className="fa fa-angle-double-left" />}
                            lastPageText={<i className="fa fa-angle-double-right" />}
                            prevPageText={<i className="fa fa-angle-left" />}
                            nextPageText={<i className="fa fa-angle-right" />}
                            activePage={parseInt(this.state.activePage)}
                            itemsCountPerPage={this.state.recordsPerPage}
                            totalItemsCount={this.state.totalRecords}
                            pageRangeDisplayed={this.state.pageRangeDisplayed}
                            onChange={this.onPageChange}
                        />
                        }
                        {this.state.fetchingResult &&
                        <div className="pager-loader-container">
                            <Loader inline="true" width="25" height="25" />
                        </div>
                        }
                    </div>
                </div>);
        }

        let mainWrapperClass = "", rightWrapperClass = "", leftWrapperClass = "left-wrapper";
        let mainWrapperStyle = {paddingTop: "65px"}, rightWrapperStyle = null;
        let leftWrapperStyle = {
            height: this.state.wrapperHeight,
            width: this.state.mapWidth,
            left: this.state.mapLeftPosition
        };
        let searchResultClass = "";
        if(this.state.showMap) {
            mainWrapperClass = "main-wrapper";
            mainWrapperStyle = {height: this.state.wrapperHeight};

            rightWrapperClass = "right-wrapper";
            rightWrapperStyle = {width: this.state.listWidth, height: this.state.wrapperHeight, overflow: 'auto'};

            searchResultClass = "prop_card";
        }

        let propcountLabelForMoreFilters = null;
        if(this.state.totalRecords && this.state.searchResult) {
            propcountLabelForMoreFilters = this.state.totalRecords + " Matching Listings";
        }

        let imageType = null;
        if(searchURLParams){
            var dcParams = decodeSearchParams(searchURLParams);
            if(dcParams && dcParams.imagetype && dcParams.imagetype !== ""){
                imageType = dcParams.imagetype;
            }
        }
        if(this.props.searchParameters_Redux.imagetype && this.props.searchParameters_Redux.imagetype !== ""){
            imageType = this.props.searchParameters_Redux.imagetype;
        }

        var addCommutePopover = (
            <Popover id="popover-save-search" style={{zIndex: "9999", maxWidth: "300px", padding: "0px"}}>
                <CommutePopup handleSelectClientCommute={this.handleSelectClientCommute} handleCommuteTimeChange={this.handleCommuteTimeChange} handleAutoComplete={this.handleAutoComplete} />
            </Popover>
        );

        var includeCommuteControl = (
            <OverlayTrigger trigger="click" placement="bottom" rootClose overlay={addCommutePopover} key="otCommute">
                <div className="includecommute-wrapper add_location">
                    <div style={{cursor: "pointer", padding: "3px 7px"}}>
                        <div className="tru-commute">
                            <img src={commute_solo} alt="Commute" />
                        </div>
                        {this.props.searchParameters_Redux && this.props.searchParameters_Redux.commutetimemins &&
                            <span className="location_icon_text">{this.props.searchParameters_Redux.commutetimemins + " mins"}</span>
                        }
                    </div>
                </div>
            </OverlayTrigger>
        );
        if(this.props.isAnonymous){
            includeCommuteControl = (
                <div onClick={(e) => {this.alertForLogin()}}>
                    <div className="includecommute-wrapper add_location">
                        <div style={{cursor: "pointer", padding: "3px 7px"}}>
                            <div className="tru-commute">
                                <img src={commute_solo} alt="Commute" />
                            </div>
                            {this.props.searchParameters_Redux && this.props.searchParameters_Redux.commutetimemins &&
                                <span className="location_icon_text">{this.props.searchParameters_Redux.commutetimemins + " mins"}</span>
                            }
                        </div>
                    </div>
                </div>
            );
        }

        var searchMapElement = null;
        if(SearchPageCustomizationOptions && SearchPageCustomizationOptions.ShowFilterWithInMap){
            searchMapElement = (
                <div className="propcount-wrapper searchmap-chk">
                    <div className="tru-checkbox-area">
                        <label className="tru-checkbox">
                            <input id="searchmap_check" type="checkbox" name="searchmap" onChange={this.onCheckChange} value={(this.props.searchParameters_Redux.searchmap) ? "true" : "false"} checked={(this.props.searchParameters_Redux.searchmap === "true") ? "checked" : ""}/>
                            <span className="tru-checkbox_checkmark"></span>
                        </label>
                        <div className="tru-checkbok-name">Filter within the Map</div>
                    </div>
                </div>
            );
        }

        var polygons = (this.props.searchParameters_Redux && this.props.searchParameters_Redux.polygon && this.props.searchParameters_Redux.polygon.length > 0)
                        ? convertPolygonUnformat(this.props.searchParameters_Redux.polygon)
                        : [];

        var currentTitle = (this.props.searchParameters_Redux && this.props.searchParameters_Redux.locationtext && this.props.searchParameters_Redux.locationtext !== '')
                            ? PageTitle.replace('{title}', 'Homes in ' + this.props.searchParameters_Redux.locationtext) : PageTitle.replace('{title}', this.state.title);
        
        const ogDesc = (MetaTagsProperties && MetaTagsProperties.search && MetaTagsProperties.search.desc) ? MetaTagsProperties.search.desc : "";
        const ogTitle = (MetaTagsProperties && MetaTagsProperties.search && MetaTagsProperties.search.title) ? MetaTagsProperties.search.title : "";
        const ogImage = (MetaTagsProperties && MetaTagsProperties.search && MetaTagsProperties.search.img) ? MetaTagsProperties.search.img : "";
        const ogUrl = window.location.toString().substr(0);  

        return (
            <DocumentTitle title={ currentTitle }>
                <div>
                    <Helmet>
                            <meta name="title" content={ogTitle} />
                            <meta name="description" content={ogDesc} />
                            <meta itemProp="name" content={ogTitle} />
                            <meta itemProp="description" content={ogDesc} />
                            <meta itemProp="image" content={ogImage} />
                            <meta name="twitter:title" content={ogTitle} />
                            <meta name="twitter:description" content={ogDesc} />
                            <meta name="twitter:image:src" content={ogImage} />
                            <meta property="og:title" content={ogTitle} />
                            <meta property="og:type" content="article" />
                            <meta property="og:url" content={ogUrl} />
                            <meta property="og:image" content={ogImage} />
                            <meta property="og:description" content={ogDesc} />
                    </Helmet>
                    <div ref="searchPageRef">
                        <div>
                            <SearchBar
                                ref={(ref) => this.searchBarRef = ref}
                                onSearch={this.onSearch}
                                onChangeView={this.onChangeView}
                                searchURLParams={searchURLParams}
                                propCountLabel={propcountLabelForMoreFilters}
                                showNotification={this.props.showNotification}
                                goToLogin={this.goToLogin} />
                        </div>
                        <div style={{position: "relative"}}>
                            <div className={mainWrapperClass} style={mainWrapperStyle}>
                                <div id="right-wrapper" className={rightWrapperClass + " " + this.state.rightWrapperClass + " scrollarea"} style={rightWrapperStyle}>
                                    <Element name="top_scroll" className="top_scroll"></Element>
                                    {(!this.state.bookmarkItems || this.state.bookmarkItems.length <= 0) &&
                                        <SearchTags
                                            searchParameters={this.props.searchParameters_Redux}
                                            onRemoveSearchTag={this.onRemoveSearchTag} />
                                    }

                                    {(!this.state.bookmarkItems || this.state.bookmarkItems.length <= 0) &&
                                    <SearchTitleBar
                                        start={this.state.activePageStart}
                                        end={this.state.activePageEnd}
                                        total={this.state.totalRecords}
                                        pagesize={this.state.recordsPerPage}
                                        orderby={(this.props.searchParameters_Redux && this.props.searchParameters_Redux.orderby) ? this.props.searchParameters_Redux.orderby : null}
                                        orderbydirection={(this.props.searchParameters_Redux && this.props.searchParameters_Redux.orderbydirection) ? this.props.searchParameters_Redux.orderbydirection : null}
                                        imagetype={(this.props.searchParameters_Redux && this.props.searchParameters_Redux.imagetype) ? this.props.searchParameters_Redux.imagetype : null}
                                        exteriorhomestyle={(this.props.searchParameters_Redux && this.props.searchParameters_Redux.exteriorhomestyle) ? this.props.searchParameters_Redux.exteriorhomestyle : null}
                                        searchURLParams={searchURLParams}
                                        onChangeSort={this.onChangeSort}
                                        onChangeImageType={this.onChangeImageType}
                                        showMap={this.state.showMap}
                                        wrapperClass={this.state.rightWrapperClass}
                                        showGrid={this.state.rightWrapperClass === "list-full" ? true : false}
                                        onChangeGridListView={this.onChangeGridListView}
                                        features={this.state.homeFeatures} />
                                    }
                                    {this.state.bookmarkItems && this.state.bookmarkItems.length > 0 &&
                                        <BookmarkTitle
                                            bookmarkedItems={this.state.bookmarkItems}
                                            onClientSelectionForBookmark={this.onClientSelectionForBookmark}
                                            {...this.props}/>
                                    }
                                    
                                    {pager}
                                    <div className={(this.state.resultList && this.state.resultList.length > 0) ? "right_content" : "right_content not_listing_cnt"}>

                                        <div>
                                            <section className="fluid row hotels-list-page scrollarea1">

                                                <div className="searchpg_list">
                                                    
                                                    <SearchResult
                                                        classname={searchResultClass}
                                                        marginBottom={"margin-bottom-10"}
                                                        properties={this.state.resultList.filter((p,i) => {
                                                            return p;
                                                        })}
                                                        initialLoad={this.state.initialLoad}
                                                        highlightMarker={this.highlightMarker}
                                                        playdownMarker={this.playdownMarker}
                                                        imageType={imageType}
                                                        bookmarkedItems={this.state.bookmarkItems}
                                                        showNotification={this.props.showNotification}
                                                        onPageReload={this.onPageReload}
                                                        fromSearchPage={true}
                                                        onBookmarkClicked={this.onBookmarkClicked}
                                                        onListingRemoved={this.onListingRemoved}
                                                        adsList={(SearchPageCustomizationOptions && SearchPageCustomizationOptions.ShowCustomAds) ? this.props.pAdsList : null}
                                                        {...this.props}/>
                                                </div>
                                            </section>
                                        </div>
                                    </div>
                                    {pager}
                                    <div className={"search_footer " + ((this.state.leftWrapperClass && this.state.leftWrapperClass !=="") ? this.state.leftWrapperClass : "list-col-1") + ((FooterCustomizationOptions && FooterCustomizationOptions.ShowCustomAds) ? " admargin" : "")}>
                                        <Footer showNotification={this.props.showNotification} />
                                    </div>
                                </div>
                                <div className={leftWrapperClass + " " + this.state.leftWrapperClass} style={leftWrapperStyle}>
                                    <div className="map-list-toggle">
                                        <div className="map_arrow_btn">
                                        <div className={"map-list-toggle-button right-item-arrow right " + this.state.mapListToggleRightButtonClass} onClick={this.moveMapToRight}><i className="fa fa-angle-right"></i></div>
                                        <div className={"map-list-toggle-button left-item-arrow left " + this.state.mapListToggleLeftButtonClass } onClick={this.moveMapToLeft}><i className="fa fa-angle-left"></i></div>
                                        </div>
                                    </div>
                                    <div>
                                        <div>
                                            <EsriLeafletMap
                                                ref={ref => this.esriMap = ref}
                                                properties={this.state.searchResult}
                                                resultsCount={this.state.resultsCount}
                                                clusters={this.state.clusters}
                                                height={this.state.wrapperHeight}
                                                searchInitiator={this.state.searchInitiator}
                                                polygon = {polygons}
                                                searchBoundaries={this.state.searchBoundaries}
                                                onMapPolygoneChanged={this.onMapPolygoneChanged}
                                                defaultMapLocation={this.props.defaultMapLocation}
                                                {...this.props}/>
                                        </div>
                                    </div>
                                    {includeCommuteControl}
                                    {searchMapElement}
                                </div>
                            </div>
                        </div>

                        {this.state.openBookmarkNote &&
                        <div>
                            <BookmarkNote
                                onBookmarkNoteSaved={this.onBookmarkNoteSaved}
                                onBookmarkNoteClosed={this.onBookmarkNoteClosed}
                                showDialog={true}
                                pageUpdatedOn={new Date()}
                                isDataFetching={this.state.isDataFetching}
                                titleMessage={<div style={{marginBottom: "10px"}}>You've selected <span style={{fontWeight: "bold"}}>{this.state.bookmarkItems.length}</span> properties for <span style={{fontWeight: "bold"}}>{this.state.SelectedClientForBookmark.FirstName} {this.state.SelectedClientForBookmark.LastName}</span></div>}/>
                        </div>
                        }
                    </div>
                </div>
           </DocumentTitle>
        );
    }
}

const mapStateToProps = (state, props) => ({
    audience: state.session.audience,
    isFetchingProfile: state.profile.isFetching,
    profile: state.profile.mine,
    selectedClient: state.entities.clients[state.clients.selectedClient],
    isFetchingClients: state.clients.isFetching,
    defaultMapLocation: state.settings.data['DefaultMapLocation'],
    notificationMessage: state.clients.notificationMessage || state.profile.notificationMessage,
    searchParameters_Redux: state.search.parameters,
    isAnonymous: state.session.isAnonymous,
    pAdsList:  (state.manage.searchpageads && state.manage.searchpageads.ids) ? state.manage.searchpageads.ids : [],
});

const mapDispatchToProps = dispatch => ({
    searchActions: bindActionCreators(searchActions, dispatch),
    sessionActions: bindActionCreators(sessionActions, dispatch),
    profileActions: bindActionCreators(profileActions, dispatch),
    clientActions: bindActionCreators(clientActions, dispatch),
    listingActions: bindActionCreators(listingActions, dispatch),
    manageActions: bindActionCreators(manageActions, dispatch),    
});

export default connect(mapStateToProps, mapDispatchToProps)(SearchPage);
